import type { i18n as I18n } from "i18next";
import en from "@/locales/en/puzzle-types/norinori.json";
import fr from "@/locales/fr/puzzle-types/norinori.json";

export const NORINORI_NS = "puzzle-types/norinori";

/** Adds this type's translations to an initialised i18next instance (idempotent). */
export function registerNorinoriTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", NORINORI_NS))
    i18n.addResourceBundle("en", NORINORI_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", NORINORI_NS))
    i18n.addResourceBundle("fr", NORINORI_NS, fr, true, true);
}
